
import BaseModel from './BaseModel';
import { TRANSLATE_LANGUAGE } from '../constants/Define';
export default class BookablePackageRate extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.hotelId = data.hotelId || undefined;
        this.bookableId = data.bookableId || undefined;
        this.name = this.translate.name || data.name || undefined;
        this.newName = this.translate.newName || data.newName || undefined;
        this.description = this.translate?.description || data?.description || "";
        this.code = data.code || undefined;
        this.refId = data.refId || undefined;
        this.seq = this.seq || 0;
        this.isDefault = data.isDefault || false;
        this.isActive = data.isActive || false;
        this.dc = data.dc || [];
        this.isStatus = data.isStatus || false;
        this.usageStatus = data.usageStatus || false;
        this.transactionCode = data.transactionCode || "";
        this.languageCode = this.languageCode ? this.languageCode : TRANSLATE_LANGUAGE.VN.code;
        this.calculationRule = data.calculationRule || "";
        this.postingRhythm = data.postingRhythm || "";
        this.imageLink = data.imageLink || undefined;
        this.amenityId = data.amenityId || undefined;
        this.targetLanguage = data.targetLanguage || [];
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            newName: this.newName,
            description: this.description,
            order: this.seq,
            isActive: this.isActive,
            languageCode: this.languageCode,
            usageStatus: this.usageStatus,
            imageLink: this.imageLink,
            amenityId: this.amenityId,
            targetLanguage: this.targetLanguage
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                name: this.name,
                newName: this.newName,
                description: this.description,
                order: this.seq,
                isActive: this.isActive,
                languageCode: this.languageCode,
                usageStatus: this.usageStatus,
            }
        }
        return result;
    }
}